// @flow
import { all, call } from "redux-saga/effects";
import type { Saga } from "redux-saga";
import getIpp from "../../sagas/getIpp";

export default function* mainSaga(): Saga<void> {
  yield all([call(getIpp)]);
}
